import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shouldShowAccountNumber"];
import { useIsDesktopDimension } from '@beef/ui-kit';
import { IconLogoutOutline, IconUserFilled } from '@carnica/graphics';
import { Button } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { findFirst } from "../../../utils/utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var LoginButton = function LoginButton(_ref) {
  var shouldShowAccountNumber = _ref.shouldShowAccountNumber,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobile = !useIsDesktopDimension();
  var iconRight = findFirst([isMobile && shouldShowAccountNumber && IconLogoutOutline, isMobile && IconUserFilled]);
  var children = shouldShowAccountNumber ? props.children : undefined;
  return findFirst([!isMobile && /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    mode: 'inline' // NOTE: типизация компонента из кита сломаная
    ,

    className: cn('button-wide'),
    iconRight: iconRight,
    onlyIcon: !children,
    view: "secondary-invert",
    "data-t-id": "HeaderButtons-LoginButton"
  }), children)]) || /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    className: cn('button'),
    iconRight: iconRight,
    onlyIcon: true,
    view: "secondary"
  }));
};